import React from 'react';
import {
  createTextSearchFilter,
  createCheckBoxFilter,
  createTableColumnSortingFilter,
  createPerPageFilter,
  createPageFilter,
} from './searchFilterInitialState';
import { TAG_STATUS_CONST } from '../../common/constant';

const query = createTextSearchFilter(
  { label: 'search_tag', param: 'search' },
  true
);

const status = createCheckBoxFilter({
  label: 'status',
  options: Object.keys(TAG_STATUS_CONST).map((key) => ({
    id: TAG_STATUS_CONST[key],
    label: TAG_STATUS_CONST[key],
  })),
  loading: false,
  loadingHeight: 250,
  default: false,
  optionCounts: Object.keys(TAG_STATUS_CONST).reduce((acc, key) => {
    acc[TAG_STATUS_CONST[key]] = null;
    return acc;
  }, {}),
  getOptions() {
    return this.options;
  },
  getOptionLabel(value, t) {
    return t(`labels.statuses.${value}`);
  },
  getPostFix(value) {
    return (
      <span className='filters__count'>
        {this.optionCounts[value.id] >= 0 ? this.optionCounts[value.id] : 0}
      </span>
    );
  },
});

const sorting = createTableColumnSortingFilter({
  defaultSortField: 'ca',
  defaultSortDir: 'desc',
});

const perPage = createPerPageFilter({ defaultVal: 25 });

const pagination = createPageFilter({ param: 'p' });

const initialState = {
  filters: { query, status, pagination, perPage, sorting },
  columns: {
    name: {
      label: 'column_name',
      id: 'name',
      numeric: false,
      sort: false,
      getLabel(t) {
        return t(this.label);
      },
    },
    icon: {
      label: 'column_icon',
      id: 'icon',
      numeric: false,
      sort: 'disabled',
      getLabel(t) {
        return t(this.label);
      },
    },
    description: {
      label: 'column_description',
      id: 'description',
      numeric: false,
      sort: false,
      getLabel(t) {
        return t(this.label);
      },
    },
    status: {
      label: 'column_status',
      id: 'status',
      numeric: false,
      sort: false,
      getLabel(t) {
        return t(this.label);
      },
    },
    no_of_tagged: {
      label: 'column_no_of_tagged',
      id: 'no_of_tagged',
      numeric: true,
      sort: false,
      getLabel(t) {
        return t(this.label);
      },
    },
    created_at: {
      label: 'column_created',
      id: 'created_at',
      numeric: false,
      sort: 'desc',
      getLabel(t) {
        return t(this.label);
      },
    },
  },
  meta: {
    loading: false,
    selected: [],
    selectedCountOfPage: 0,
    total: 0,
    stateChange: {
      active: false,
      requestInProgress: false,
    },
    lastSearch: '',
  },
  data: [],
};

export const tagManageInitialState = {
  isAddEditEnable: false,
  isCreateMode: true,
  tag: {},
};

export default initialState;
